import { render, staticRenderFns } from "./preview-skills.vue?vue&type=template&id=0989edc2&scoped=true"
import script from "./preview-skills.vue?vue&type=script&lang=js"
export * from "./preview-skills.vue?vue&type=script&lang=js"
import style0 from "./preview-skills.vue?vue&type=style&index=0&id=0989edc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0989edc2",
  null
  
)

export default component.exports